const _tableImport = {
    excleHead: [
        // status
        {
            title: "Status Import",
            dataIndex: "status_import",
            scopedSlots: { customRender: "status_import" },
            width: 100,
            // fixed: "left",
            className: "center-colum column-header-fix-data-s",
        },
        // status detail
        {
            title: "Status Import Detail",
            dataIndex: "status_detail",
            scopedSlots: { customRender: "status_detail" },
            width: 150,
            // fixed: "left",
            className: "center-colum column-header-fix-data-s",
        },        
        {
            title: "Student_ID",
            dataIndex: "student_id",
            key: "student_id",
            width: 80,
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },
        {
            title: "Position",
            dataIndex: "position_name",
            scopedSlots: { customRender: "position_name" },
            // fixed: "left",
            width: 150,
            className: "center-colum column-header-fix-data",
        },
        {
            title: "Company Name",
            dataIndex: "company_name",
            scopedSlots: { customRender: "company_name" },
            // fixed: "left",
            width: 150,
            className: "center-colum column-header-fix-data",
        },{
            title: "Job Sector",
            dataIndex: "job_sector",
            width: 100,
            scopedSlots: { customRender: "job_sector" },
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },
    ],
}

export default _tableImport;
